// extracted by mini-css-extract-plugin
export var content = "_ai-3";
export var list = "_ai-4";
export var settingsContent = "_ai-7";
export var settingsPanel = "_ai-8";
export var state = "_ai-6";
export var triggerBadge = "_ai-2";
export var triggerButton = "_ai-1";
export var triggerShell = "_ai-0";
export var unreadDot = "_ai-5";